import classNames from 'classnames/bind';
import styles from './Container.module.css';

import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../hooks/useSimpleBar';

import { useAppSelector } from '../../hooks/useRedux';
import { selectMenu } from '../../features/infoSlice';
import { useLocation } from 'react-router-dom';
import { selectUserType } from '../../features/authSlice';

interface ContainerProps {
  isSubPage?: boolean;
  children: React.ReactNode;
}

export default function Container({ isSubPage, children }: ContainerProps) {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);
  const userType = useAppSelector(selectUserType);

  const [simplebarRef] = useSimpleBar();
  const { pathname } = useLocation();
  const isActivityInfo = pathname.includes('activity');

  return (
    <div className={cx('cloud--container', menu)}>
      <SimpleBar forceVisible={true} ref={simplebarRef}>
        <div
          className={cx(
            'container',
            { st_main: menu === 'main' },
            { tc_main: userType === 1 },
            { 'st_main-v2': userType === 2 },
            { st_subpage: isSubPage },
            { st_dash: isActivityInfo },
            menu
          )}
        >
          <div className={cx('inner')}>{children}</div>
        </div>
      </SimpleBar>
    </div>
  );
}
